jQuery(document).ready(function ($) {

	$(".js-select-register-form").select2({
		minimumResultsForSearch: Infinity,
		width: "100%",
		theme: "register-form",
		placeholder: function () {
			return {
				id: "-1",
				text: $(this).data("placeholder"),
			};
		},
		templateResult: formatOption,
		templateSelection: formatOption,
	});

	function formatOption(option) {
		if (!option.id) {
			return option.text;
		}

		const iconSrc = $(option.element).data("icon-src");

		return iconSrc ? $("<span><img width=\"16\" height=\"12\" src=\"" + iconSrc + "\" class=\"custom-icon\" /> " + option.text + "</span>") : option.text;
	}

	$(".js-select-results").select2({
		minimumResultsForSearch: Infinity,
		width: "100%",
		theme: "results",
	});
});
